import { createContext } from "react";

import type { DrawerOverrideContextValue } from "./types";

export const DrawerOverrideContext =
  createContext<DrawerOverrideContextValue | null>(null);
DrawerOverrideContext.displayName = "DrawerOverrideContext";
